import axios from 'axios';
import { Video, ErrorResponse } from '../types';

declare global {
  interface Window {
    API_BASE_URL?: string;
  }
}

export const API_BASE_URL = window.API_BASE_URL || 'http://localhost:8080';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Function to set JWT token header
export const setAuthHeader = (token: string) => {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  sessionStorage.setItem('authToken', token);
};

// Function to clear auth header
export const clearAuthHeader = () => {
  delete api.defaults.headers.common['Authorization'];
  sessionStorage.removeItem('authToken');
};

// Load token from sessionStorage
const token = sessionStorage.getItem('authToken');
if (token) {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

export const healthCheck = async (): Promise<{ status: string }> => {
  const response = await api.get('/api/health');
  return response.data;
};

export interface LoginResponse {
  token: string;
}

export const login = async (username: string, password: string): Promise<LoginResponse> => {
  const response = await api.post('/api/login', { username, password });
  return response.data;
};

export const getVideos = async (from?: string, to?: string): Promise<Video[]> => {
  const params: any = {};
  if (from) params.from = from;
  if (to) params.to = to;
  const response = await api.get('/api/videos', { params });
  return response.data;
};

export default api;